import {ScoringPage} from './ScoringPage';
export default ScoringPage;